import { Button } from "react-bootstrap";
import { useAuth } from "react-oidc-context";
import { Navigate, useNavigate } from "react-router";

const RedirectPage = () => {
  const navigate = useNavigate();
  const auth = useAuth();

  const userState = auth.user?.state;

  const handleLoggUt = async (e) => {
    await auth.removeUser();
    navigate("/login");
  };

  if (auth.error) {
    return (
      <div style={{ padding: 50 }}>
        <div style={{ marginBottom: 20 }}>
          {auth.error.name + ": " + auth.error.message}
        </div>
        <div style={{ marginTop: 20 }}>
          <Button onClick={handleLoggUt}>Gå til logg inn</Button>
        </div>
      </div>
    );
  }

  if (auth.isLoading) {
    return <div>Logger inn...</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <Navigate
        to={
          userState
            ? userState.from.pathname +
              userState.from.search +
              userState.from.hash
            : "/"
        }
        replace
      />
    );
  }

  if (!auth.isAuthenticated && !auth.isLoading) {
    return <Navigate to="/login" replace />;
  }

  return <></>;
};

export default RedirectPage;
